<!--门店休息设置-->
<template>
  <div class="root-container">
    <el-form    label-width="140px">
      <el-form-item label="选课上课日期:">
        <el-date-picker style="width: 300px;"
          @change="changeDay"
          v-model="queryParam.dayTime"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="选择课程:">
        <el-select v-model="storeReleaseLessonId" placeholder="请选择" style="width: 300px;">
          <el-option
            v-for="item in storeReleaseLessons"
            :key="item.id"
            :label="praseLessonName(item)"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>


    </el-form>
    <div slot="footer" class="dialog-footer-1" >
      <el-button style="background-color: #F14B39 ;color: white;" @click="onSelectLesson()">确认</el-button>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>

  import timeUtils from "../../utils/timeUtils";
  import globaldata from "../../utils/globaldata";
  import {qlDayReleaseLessons} from "../../api/StoreReleaseLesson";
  import commonUtils from "../../utils/commonUtils";
  import enumsUtil from "../../utils/enumsUtil";


  export default {
    name: 'SelectDayReleaseLesson',
    props: {

    },
    data() {
      return {
        queryParam:{
          dayTime:'',
        },
        templates:'',
        storeReleaseLessonId:"",
        //店铺发布的课程
        storeReleaseLessons:[],
      }
    },
    created(){
      this.initData();

    },
    methods: {

      initData(){


      },

      praseLessonName(lesson){
        if (lesson.lessonTemplateId == enumsUtil.lessonTemplateIdBS()){
          let tStr =  timeUtils.transTimeHM(lesson.classStartTime) + '~' + timeUtils.transTimeHM(lesson.classEndTime);
          let ms ="";
          if (lesson.startMonth < 8){
            ms = "婴儿"
          }else {
            ms = "幼儿"
          }
          return lesson.name +'/'+ms +'('+ tStr+ ')';
        }else {
          let tStr =  timeUtils.transTimeHM(lesson.classStartTime) + '~' + timeUtils.transTimeHM(lesson.classEndTime);
          return lesson.name +'('+ tStr+ ')';
        }

      },

      qlDayReleaseLessons(day){
        let dayTime = timeUtils.transDayInt(day);
        let param = {
          dayTime:dayTime,
          lessonTemplateId:this.templates,
          storeFrontId:globaldata.getAdminStore().storeFrontId
        }
        qlDayReleaseLessons(param).then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.storeReleaseLessons = data;
        })

      },
      changeDay(val){
        this.qlDayReleaseLessons(val);
      },

      onSelectLesson(){
        for (let i =0;i< this.storeReleaseLessons.length;++i){
          if (this.storeReleaseLessonId == this.storeReleaseLessons[i].id){
            this.$emit('onSelectLesson',this.storeReleaseLessons[i]);
          }
        }
      },

    },


  }
</script>






// WEBPACK FOOTER //
// src/views/components/SelectDayReleaseLesson.vue